module.exports = __webpack_public_path__ + "static/specialists-slideshow-06@2x-7fed2c3e3190d5c026df5cd865f82024.jpg";